<div class="layout" *ngIf="isConfigLoaded">
  <div class="layout-erreur">
    <div class="conteneur-erreur">
      <img id="unavailable_1" src="{{ 'assets/images/unavailable.svg' | cheminAbsoluStatique }}" alt="" />
      <h2 class="erreur-titre">{{ 'erreur.libelle' | translate }}</h2>
      <div class="erreur-texte">
        <span class="error-explanation">{{ 'erreur.ligne-1' | translate }}</span>
      </div>
      <a mat-button class="no-border action-retour" id="action-retour" href="/">
        <img
          src="{{ 'assets/images/fleche-verte.svg' | cheminAbsoluStatique }}"
          alt=""
          width="6"
          height="12"
          class="chevron"
        />
        {{ 'erreur.retour' | translate }}
      </a>
    </div>
  </div>
</div>

<div class="layout" *ngIf="!isConfigLoaded && !isPDOFusionPending">
  <div class="layout-erreur">
    <div class="conteneur-erreur">
      <div class="erreur">
        <img
          id="unavailable_2"
          src="{{ 'assets/images/unavailable.svg' | cheminAbsoluStatique }}"
          alt=""
          width="474"
          height="268"
        />
        <h2 class="erreur-titre">Oups! Une erreur s’est produite</h2>
        <div class="erreur-texte">
          <span class="error-explanation">Veuillez réessayer dans quelques minutes.</span>
        </div>
        <a mat-button class="no-border action-retour" id="action-retour-fr" href="/">
          <img
            src="{{ 'assets/images/fleche-verte.svg' | cheminAbsoluStatique }}"
            alt=""
            width="6"
            height="12"
            class="chevron"
          />
          Retour au tableau de bord
        </a>
      </div>

      <div class="erreur">
        <img
          id="unavailable_3"
          src="{{ 'assets/images/unavailable.svg' | cheminAbsoluStatique }}"
          alt=""
          width="474"
          height="268"
        />
        <h2 class="erreur-titre">Oops! Something’s gone wrong</h2>
        <div class="erreur-texte">
          <span class="error-explanation">Please try again in a few minutes.</span>
        </div>
        <a mat-button class="no-border action-retour" id="action-retour-en" href="/">
          <img
            src="{{ 'assets/images/fleche-verte.svg' | cheminAbsoluStatique }}"
            alt=""
            width="6"
            height="12"
            class="chevron"
          />
          Back to dashboard
        </a>
      </div>
    </div>
  </div>
</div>

<div class="layout" *ngIf="!isConfigLoaded && isPDOFusionPending">
  <div class="layout-erreur">
    <div class="conteneur-erreur">
      <img
        id="unavailable_4"
        src="{{ 'assets/images/caisse-non-eligible.svg' | cheminAbsoluStatique }}"
        alt=""
        class="image"
      />
      <h2 class="erreur-titre"></h2>
      <div class="erreur-texte">
        <p class="error-explanation">
          Nous avons besoin d’un peu de temps pour regrouper vos comptes. Veuillez vous reconnecter plus tard.
        </p>
        <p class="error-explanation">We need a bit more time to merge your accounts. Please log in again later.</p>
      </div>
    </div>

    <div class="page-footer">
      <a mat-button class="no-border action-precedent" id="action-precedent" (click)="retourAccueil()">
        <img
          src="{{ 'assets/images/fleche-verte.svg' | cheminAbsoluStatique }}"
          alt=""
          width="6"
          height="12"
          class="chevron"
        />
        Retour sur Desjardins.com
      </a>
    </div>
  </div>
</div>
